import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface DeleteTransitProps {
  id: string;
}

export const useDeleteTransit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }: DeleteTransitProps) => {
      const result = await apiClient.transit.deleteTransit.mutation({ params: { id } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      toast.success(`Transit deleted!`);
    },
    onError: (error) => {
      showErrorToast(error, `Error deleting the transit!`);
    },
  });
};
